<div class="wager-card-wrapper">
  <canvas #confettiCanvas class="confetti-canvas"></canvas>
  <div
    role="button"
    class="wager-card"
    [ngClass]="{
      disabled: isDisabled(),
      locked: effectiveLockState() === 'locked',
      'in-progress': effectiveLockState() === 'inprogress',
      'celebrating-unlock': celebrationState() === 'unlock',
      'celebrating-unlock-transition': celebrationState() === 'unlock-transition',
      'celebrating-inprogress': celebrationState() === 'inprogress',
    }"
    (animationend)="onAnimationEnd($event)"
    [ngStyle]="cardStyle() | theme"
    [style.padding-top]="topPadding"
    [style.padding-bottom]="bottomPadding"
    [style.padding-left]="leftPadding"
    [style.padding-right]="rightPadding"
    [style.--unlock-progress-start]="celebrationStartPercent() + '%'"
    [style.--inprogress-target-percent]="progressPercent() + '%'"
    (keydown.enter)="onClick()"
    (keydown.space)="onClick()"
    (click)="onClick()"
    [attr.tabindex]="isDisabled() || lockState() !== 'unlocked' ? -1 : 0"
    [attr.aria-disabled]="isDisabled() || lockState() !== 'unlocked'"
    [attr.aria-label]="
      title + ' — win ' + primaryPrizeAmount().text + ', enter ' + primaryEntryAmount().text
    "
  >
    @if (splicedBg) {
      <app-spliced-background
        [image]="splicedBg.imageUrl"
        [cornerSize]="splicedBg.cornerSize"
        [disabled]="isDisabled()"
      />
    }
    @if (hasWaitingOpponent() && !isDisabled()) {
      <app-icon
        icon="player-waiting"
        [colorCss]="playerWaitingColor"
        sizeCss="--icon-medium"
        class="player-waiting-icon"
      />
    }
    <div [ngStyle]="titleStyles() | theme">
      {{ title }}
    </div>
    <div class="prize-container">
      @if (primaryPrizeAmount().icon && primaryPrizeAmount().iconPosition === "start") {
        <app-currency-icon [icon]="primaryPrizeAmount().icon!" sizeCss="--icon-medium" />
      }
      <div class="prize-stack">
        @if (hasPrizeShadow()) {
          <div [ngStyle]="prizeShadowStyles() | theme" class="prize-shadow">
            {{ primaryPrizeAmount().text }}
          </div>
        }
        <div [ngStyle]="prizeStyles() | theme" class="prize-text">
          {{ primaryPrizeAmount().text }}
        </div>
      </div>
      @if (primaryPrizeAmount().icon && primaryPrizeAmount().iconPosition === "end") {
        <app-currency-icon [icon]="primaryPrizeAmount().icon!" sizeCss="--icon-medium" />
      }

      @if (hasSecondaryCurrency()) {
        <div class="secondary-span">
          <div class="prize-stack">
            @if (hasPrizeShadow()) {
              <div [ngStyle]="prizeShadowStyles() | theme" class="prize-shadow">
                {{ "(" }}
              </div>
            }
            <div [ngStyle]="prizeStyles() | theme" class="prize-text">
              {{ "(" }}
            </div>
          </div>
          <div class="secondary-icon-span">
            @if (secondaryPrizeAmount().icon && secondaryPrizeAmount().iconPosition === "start") {
              <app-currency-icon [icon]="secondaryPrizeAmount().icon!" sizeCss="--icon-medium" />
            }
            <div class="prize-stack">
              @if (hasPrizeShadow()) {
                <div [ngStyle]="prizeShadowStyles() | theme" class="prize-shadow">
                  {{ secondaryPrizeAmount().text }}
                </div>
              }
              <div [ngStyle]="prizeStyles() | theme" class="prize-text">
                {{ secondaryPrizeAmount().text }}
              </div>
            </div>
            @if (secondaryPrizeAmount().icon && secondaryPrizeAmount().iconPosition === "end") {
              <app-currency-icon [icon]="secondaryPrizeAmount().icon!" sizeCss="--icon-medium" />
            }
          </div>
          <div class="prize-stack">
            @if (hasPrizeShadow()) {
              <div [ngStyle]="prizeShadowStyles() | theme" class="prize-shadow">
                {{ ")" }}
              </div>
            }
            <div [ngStyle]="prizeStyles() | theme" class="prize-text">
              {{ ")" }}
            </div>
          </div>
        </div>
      }
    </div>
    <div class="label-slot">
      @if (effectiveLockState() !== "inprogress" || celebrationState() === "unlock-transition") {
        <div class="entry-container">
          <div [ngStyle]="enterStyle() | theme">
            {{ prefixLabel }}
          </div>
          @if (primaryEntryAmount().icon && primaryEntryAmount().iconPosition === "start") {
            <app-currency-icon [icon]="primaryEntryAmount().icon!" sizeCss="--icon-small" />
          }
          <div [ngStyle]="feeStyle() | theme">
            {{ primaryEntryAmount().text }}
          </div>
          @if (primaryEntryAmount().icon && primaryEntryAmount().iconPosition === "end") {
            <app-currency-icon [icon]="primaryEntryAmount().icon!" sizeCss="--icon-small" />
          }
          @if (hasSecondaryCurrency()) {
            <div class="secondary-span">
              <div [ngStyle]="feeStyle() | theme">
                {{ "(" }}
              </div>
              <div class="secondary-icon-span">
                @if (
                  secondaryEntryAmount().icon && secondaryEntryAmount().iconPosition === "start"
                ) {
                  <app-currency-icon [icon]="secondaryEntryAmount().icon!" sizeCss="--icon-small" />
                }
                <div [ngStyle]="feeStyle() | theme">
                  {{ secondaryEntryAmount().text }}
                </div>
                @if (secondaryEntryAmount().icon && secondaryEntryAmount().iconPosition === "end") {
                  <app-currency-icon [icon]="secondaryEntryAmount().icon!" sizeCss="--icon-small" />
                }
              </div>
              <div [ngStyle]="feeStyle() | theme">
                {{ ")" }}
              </div>
            </div>
          }
        </div>
      }
      @if (
        effectiveLockState() === "inprogress" ||
        celebrationState() === "unlock-transition" ||
        celebrationState() === "inprogress"
      ) {
        <div class="progress-bar-container">
          <div class="progress-bar-track">
            <div class="progress-bar-fill" [style.width.%]="progressPercent()"></div>
          </div>
          <div class="progress-counter-stack">
            <span
              class="progress-counter progress-counter--previous"
              [ngStyle]="progressCounterStyle | theme"
              >{{ previousCounterText() }}</span
            >
            <span
              class="progress-counter progress-counter--current"
              [ngStyle]="progressCounterStyle | theme"
              >{{ currentCounterText() }}</span
            >
          </div>
        </div>
      }
    </div>
    <div #buttonSlot class="button-slot">
      @if (effectiveLockState() === "unlocked" || celebrationState() === "unlock-transition") {
        <div class="play-button" [ngStyle]="playButtonStyles | theme">
          @if (splicedPlayBg) {
            <app-spliced-background
              [image]="splicedPlayBg.imageUrl"
              [cornerSize]="splicedPlayBg.cornerSize"
            />
          }
          <span [ngStyle]="playButtonLabelStyles | theme">{{ playLabel }}</span>
        </div>
      }
      @if (
        effectiveLockState() === "inprogress" ||
        celebrationState() === "unlock-transition" ||
        celebrationState() === "inprogress"
      ) {
        <div class="inprogress-button" [ngStyle]="inProgressButtonStyles | theme">
          @if (splicedInProgressBg) {
            <app-spliced-background
              [image]="splicedInProgressBg.imageUrl"
              [cornerSize]="splicedInProgressBg.cornerSize"
            />
          }
          <div class="inprogress-label-stack">
            <span
              class="inprogress-label inprogress-label--count"
              [ngStyle]="inProgressButtonLabelStyles | theme"
              >{{ previousInProgressLabel() }}</span
            >
            <span
              class="inprogress-label inprogress-label--unlocking"
              [ngStyle]="inProgressButtonLabelStyles | theme"
              >{{ unlockingLabel }}</span
            >
          </div>
        </div>
      }
      @if (effectiveLockState() === "locked" || celebrationState() === "inprogress") {
        <div class="locked-button" [ngStyle]="lockedButtonStyles | theme">
          @if (splicedLockedBg) {
            <app-spliced-background
              [image]="splicedLockedBg.imageUrl"
              [cornerSize]="splicedLockedBg.cornerSize"
            />
          }
          <span [ngStyle]="lockedButtonLabelStyles | theme">{{ lockedLabel }}</span>
        </div>
      }
    </div>
  </div>
</div>
